/** @deprecated - use ~/inputs/TextInput instead */
export { TextInput } from "./TextInput";
